import React from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'
import HoverButton from './HoverButton'


@inject("store")
@observer
export default class EventType extends React.Component {
  static propTypes = {
    store: PropTypes.object.isRequired
  }

  handleClick = (e, eventType) => {
    const { store } = this.props
    e.preventDefault()
    store.progress({ eventType })
  }

  render() {
    const { store, eventType } = this.props
    const { name, id } = eventType.attributes
    const { primaryColor, contrastColor } = store.franchise.attributes

    return (
      <HoverButton
        href="#choosePackage"
        className="btn btn-secondary package"
        onClick={(e) => this.handleClick(e, eventType)}
        style={{ color: primaryColor, backgroundColor: contrastColor, borderColor: primaryColor }}
        hoverStyle={{ color: contrastColor, backgroundColor: primaryColor, borderColor: primaryColor }}
      >
        { name }
      </HoverButton>
    )
  }
}
